import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Utworzenie instancji klienta zapytań
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false, // WYŁĄCZ retry - nie ponawiaj żadnych zapytań globalnie
      staleTime: 5 * 60 * 1000 // 5 minut
    },
  },
});

interface QueryProviderProps {
  children: React.ReactNode;
}

/**
 * Provider konfigurujący React Query dla aplikacji
 */
export const QueryProvider: React.FC<QueryProviderProps> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
};

export { queryClient };
